export const IMAGE_COUNT_LIMIT_FOR_INSPECTION = 10
export const IMAGE_COUNT_LIMIT_FOR_INSPECTION_RESULT = 5
